/* eslint-disable */
import React, { Component } from 'react'
import { View, Text, Image, TouchableOpacity } from 'react-native'
import { getAvatar } from '../Lib/utils'
import {Fonts} from '../Themes'
import I18n from "i18n-js"

export default class UserFollowComponent extends Component {
  constructor(props) {
    super(props)
    this.state = { following : this.props.data.Following }
  }
  select = ( ) => {
    this.setState({ following : this.state.following? false: true }
    , ( ) => { // this is the state after the change, the state we want to request from the API
      if( this.state.following )
        this.props.api.followUser( this.props.auth.user.UserId, this.props.data.UserId )
      else
        this.props.api.unfollowUser( this.props.auth.user.UserId, this.props.data.UserId )
    })
  }
  render( ) {
    // backgroundColor #4BD963
    const { data, fontSize = 12 } = this.props
    // let data = this.props.data
    return (
      <View style={{ flexDirection : 'row', justifyContent: 'space-between'
                  , backgroundColor : 'white', height : 60, width : '100%', alignItems : 'center' }}>

        <TouchableOpacity activeOpacity={0.5} onPress={( ) => this.props.navigation.navigate('profilePost2', { userId : data.UserId }) }
                          style={{ flex : 0.6, flexDirection : 'row', alignItems : 'center' }}>
          <Image source={{ uri: getAvatar(data.UserId) }} resizeMode='contain'
                style={{ width : 30, height : 30, borderRadius : 15, margin : 10, marginRight : 10, marginLeft : 15 }} />
          <Text style={{ fontFamily : Fonts.style.font.bold, fontSize : fontSize }}>{data.Username}</Text>
        </TouchableOpacity>

        { this.props.auth.user.UserId !== this.props.data.UserId &&
          <TouchableOpacity activeOpacity={0.5} onPress={this.select}
              style={{ backgroundColor : (this.state.following?'white':'black'), borderColor : (this.state.following?'#000000FF':'#00000070'), borderWidth : 1, borderRadius : 5
                      , padding : 3, width: 100, alignItems: 'center', margin : 15 }}>
            <Text style={{fontFamily : Fonts.style.font.bold, fontSize : fontSize, color: this.state.following?'black':'white'}}>{this.state.following ? I18n.t('followersProfile.followingLC') : I18n.t('followersProfile.followLC')}</Text>
          </TouchableOpacity>
        }

      </View>
    )
  }
}
